module.exports = __webpack_public_path__ + "media/images/ohap_question_bank_on-1eb52644ffd1fdc496cad1cc9610cebb.png";